import React from 'react';
import styles from './TextEffectsNeonSign.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';
import cx from 'clsx';
import { usePatterns, Patterns } from '../../TextEffectsShared/viewer/patterns';

export type TextEffectsNeonSignProps = TextEffectsSharedProps;

const TextEffectsNeonSign: React.FC<TextEffectsSharedProps> = props => {
  const { content, arePatternsDisabled } = usePatterns(props);

  return (
    <TextEffectsShared
      {...props}
      arePatternsDisabled={arePatternsDisabled}
      tagProps={{
        animated: true,
        'data-testid': TestIds.viewer.container,
      }}
    >
      <Patterns
        content={content}
        arePatternsDisabled={arePatternsDisabled}
        patternScope={props.patternScope}
        unitProps={() => ({
          className: cx(styles.text, styles.block),
          'data-testid': TestIds.viewer.text,
          disabledPattern: arePatternsDisabled,
        })}
      />
    </TextEffectsShared>
  );
};

export default TextEffectsNeonSign;
